export const CACHE_PAST_DAYS = 5;

export const CACHE_FUTURE_DAYS = 30;
